// src/components/Auth/ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authStorage } from '../../lib/storage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) =>
{
  const { isLoading } = useAuth();

  // Mostrar indicador de carga mientras se verifica autenticación
  if (isLoading)
  {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#5dade2]"></div>
      </div>
    );
  }

  // Solo validar que exista el token
  const access_token = authStorage.getAccessToken();
  if (!access_token)
  {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
